import { render, staticRenderFns } from "./AbSelect.vue?vue&type=template&id=480bcaac"
import script from "./AbSelect.vue?vue&type=script&lang=js"
export * from "./AbSelect.vue?vue&type=script&lang=js"
import style0 from "./AbSelect.vue?vue&type=style&index=0&id=480bcaac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports